<!-- 查询支持月票的车场列表 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                parkCodes: ["2KKN61D2","2KPKIGSL","2KMAMH7L"]
            },
            responseCode: {
                "data": {
                    "recordList": [
                        {
                            "parkCode": "2KPKIGSL",
                            "parkName": "性能测试停车场",
                            "parkNamePinyin": "XNCSTCC"
                        },
                        {
                            "parkCode": "2KKN61D2",
                            "parkName": "云开发测试车场",
                            "parkNamePinyin": "YKFCSCC"
                        },
                        {
                            "parkCode": "2KMAMH7L",
                            "parkName": "中间件测试停车点",
                            "parkNamePinyin": "ZJJCSTCD"
                        }
                    ]
                },
                "message": "业务成功", "resultCode": 0, "status": 1
                },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取支持月票的车场列表",
                t_url: this.commonUrls.test+"querySupportMonthTicketParkList",
                p_url: this.commonUrls.prod+"querySupportMonthTicketParkList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'parkCodes', info2: '是', info3: 'JSONArray', info4: '停车场编码列表' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '停车场列表，parkName：停车场名称,parkCode：停车场编码' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkNamePinyin', info2: '是', info3: 'String', info4: '停车场名称拼音首字母' },

                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/query/querySupportMonthTicketParkList.vue